export const resolveCssCustomProperty = (name: string): string => {
  const root = document.documentElement;
  const style = getComputedStyle(root);
  const value = style.getPropertyValue(name);

  return value;
};
